export default __webpack_public_path__ + "static/media/insightdata_modifier.baf57ee2.svg";